module.exports = __webpack_public_path__ + "img/logo_symbol.a968a0c1.svg";